import { css } from "@emotion/css";
import { theme } from "@repo-sapiens/theme";
import { ReactWithSeach } from "../../../components";
import React from "react";

type Props = {
  label: string;
  options: { value: string; label: string }[];
  defaultValue?: { value: string; label: string };
  onChange: (value: string) => void;
};
export const SelectFormItem: React.FC<Props> = ({
  label,
  options,
  defaultValue,
  onChange,
}) => {
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
      `}
    >
      <label
        className={css`
          font-size: ${theme.font["body-2xs"].fontSize};
          color: ${theme.colors.text.seconday};
          margin-bottom: 4px;
        `}
      >
        {label}
      </label>
      <ReactWithSeach
        options={options}
        defaultValue={defaultValue}
        onChange={onChange}
      />
    </div>
  );
};
